import React, { createContext, useState, ReactNode, useContext } from "react";
import { Guardian } from "../services/Dtos";

interface GuardiansContextType {
  selectedGuardian: Guardian | null;
  setSelectedGuardian: React.Dispatch<React.SetStateAction<Guardian | null>>;
}

interface Props {
  children: ReactNode;
}

const GuardiansContext = createContext<GuardiansContextType | undefined>(
  undefined
);

export const GuardiansProvider = ({ children }: Props) => {
  // const [, setIsLoading] = useState(true);
  const [selectedGuardian, setSelectedGuardian] = useState<Guardian | null>(
    null
  );

  return (
    <GuardiansContext.Provider
      value={{
        //addGuardian,
        //editGuardian,
        selectedGuardian,
        setSelectedGuardian,
        //deleteGuardian,
      }}
    >
      {children}
    </GuardiansContext.Provider>
  );
};

export const useGuardiansContext = () => {
  const context = useContext(GuardiansContext);
  if (!context) {
    throw new Error(
      "useGuardiansContext must be used within a GuardianProvider"
    );
  }
  return context;
};
